@if (visible()) {
  <button type="button" class="nv-venue-switcher__trigger" [nvMenuTriggerFor]="venueMenu">
    <nv-icon [size]="16">storefront</nv-icon>
    <span class="nv-venue-switcher__label">Switch venue</span>
    <nv-icon [size]="16">expand_more</nv-icon>
  </button>
  <ng-template #venueMenu>
    <div nvMenu>
      @for (item of items(); track item.id) {
        <button
          type="button"
          nvMenuItem
          class="nv-venue-switcher__item"
          [class.nv-venue-switcher__item--active]="item.id === activeVenueId()"
          (click)="select(item.id)"
        >
          @if (item.id === activeVenueId()) {
            <nv-icon [size]="16">check</nv-icon>
          }
          {{ item.name }}
        </button>
      }
    </div>
  </ng-template>
}
